export default "__VITE_ASSET__DRGUxZJ$__"